import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { ActivityLogEntryType } from '~/models';
const stripRelationshipIds = (entries)=>{
    if (!Array.isArray(entries)) return entries;
    return entries.map((entry)=>{
        var _entry_dto;
        if ((entry === null || entry === void 0 ? void 0 : (_entry_dto = entry.dto) === null || _entry_dto === void 0 ? void 0 : _entry_dto.type) !== ActivityLogEntryType.Relationship) return entry;
        const next = _object_spread({}, entry);
        if (next.dto) {
            const _next_dto = next.dto, { id: _dtoId } = _next_dto, restDto = _object_without_properties(_next_dto, [
                "id"
            ]);
            next.dto = restDto;
        }
        if (next.agreementDTO) {
            const _next_agreementDTO = next.agreementDTO, { id: _agreementId } = _next_agreementDTO, restAgreement = _object_without_properties(_next_agreementDTO, [
                "id"
            ]);
            next.agreementDTO = restAgreement;
        }
        return next;
    });
};
const toComparable = (value)=>stripRelationshipIds(JSON.parse(JSON.stringify(value)));
export const diffActivityLogs = (oldResult, newResult)=>{
    if (JSON.stringify(toComparable(oldResult)) === JSON.stringify(toComparable(newResult))) {
        return null;
    }
    return {
        kind: 'mismatch',
        oldLength: oldResult.length,
        newLength: newResult.length
    };
};
export const buildDiffPayload = (args)=>({
        relationshipId: args.relationshipId,
        ffOpen: args.ffOpen,
        diff: args.diff,
        oldResult: args.oldResult,
        newResult: args.newResult,
        timestamp: args.timestamp
    });
